export const READABLE_ERRORS = [
  {
    regex: new RegExp('^Drug with NDC ".*" already exists for pharmacy', 'ig'),
    readableError: 'Drug with provided NDC already exists for your pharmacy.',
  },
];
